'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _UploadDropzoneModule = require('./UploadDropzone.module.css');

var _UploadDropzoneModule2 = _interopRequireDefault(_UploadDropzoneModule);

var _TileModule = require('./overrides/Tile.module.css');

var _TileModule2 = _interopRequireDefault(_TileModule);

var _reactHoc = require('@mindz/react-hoc');

var _Tile = require('../UploadGallery/components/Tile');

var _Tile2 = _interopRequireDefault(_Tile);

var _UploadProgress = require('./components/UploadProgress');

var _UploadProgress2 = _interopRequireDefault(_UploadProgress);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UploadIcon = function UploadIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('path', {
    fill: '#FF4056',
    fillRule: 'evenodd',
    d: 'M22 21.414l-6.293 6.293a1 1 0 0 1-1.414-1.414l8-8a1 1 0 0 1 1.414 0l8 8a1 1 0 0 1-1.414 1.414L24 21.414V37a1 1 0 0 1-2 0V21.414zm13.017-9.39a11 11 0 0 1 6.336 19.998 1 1 0 0 1-1.15-1.636 9 9 0 0 0-5.185-16.362h-2.52a1 1 0 0 1-.968-.752A15 15 0 1 0 5.767 26.941a1 1 0 0 1-1.498 1.325 17 17 0 1 1 28.987-16.242h1.761z'
  }));
};

UploadIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '47',
  height: '38',
  viewBox: '0 0 47 38'
};

var UploadDropzone = function (_Component) {
  _inherits(UploadDropzone, _Component);

  function UploadDropzone() {
    _classCallCheck(this, UploadDropzone);

    return _possibleConstructorReturn(this, (UploadDropzone.__proto__ || Object.getPrototypeOf(UploadDropzone)).apply(this, arguments));
  }

  _createClass(UploadDropzone, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cx = _props.cx,
          label = _props.label,
          handleUpload = _props.handleUpload,
          isUploading = _props.isUploading,
          isPlaceholder = _props.isPlaceholder,
          isMultipleFiles = _props.isMultipleFiles,
          maxSizeMb = _props.maxSizeMb,
          acceptFiles = _props.acceptFiles,
          isSuccess = _props.isSuccess,
          TileComponent = _props.TileComponent;

      var Dropzone = _react2.default.createElement(_reactDropzone2.default, {
        className: cx('dropzone'),
        accept: acceptFiles,
        onDrop: handleUpload,
        maxSize: parseInt(maxSizeMb) * 1024 * 1024,
        multiple: isMultipleFiles,
        disabled: isUploading
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps,
            isDragActive = _ref.isDragActive;
        return _react2.default.createElement('div', getRootProps(), _react2.default.createElement('input', getInputProps()), isPlaceholder && _this2.renderPlaceholder());
      });

      if (!isMultipleFiles && isUploading) {
        Dropzone = this.renderProgress();
      }

      if (!isMultipleFiles && isSuccess) {
        Dropzone = this.renderUploaded();
      }

      return _react2.default.createElement(TileComponent, {
        customStyles: _TileModule2.default
      }, _react2.default.createElement('div', {
        className: cx('root')
      }, _react2.default.createElement('span', {
        className: cx('label')
      }, label || ''), Dropzone));
    }
  }, {
    key: 'renderPlaceholder',
    value: function renderPlaceholder() {
      var _props2 = this.props,
          cx = _props2.cx,
          icon = _props2.icon,
          titleSmall = _props2.titleSmall,
          title = _props2.title,
          subtitle = _props2.subtitle;
      return _react2.default.createElement('div', {
        className: cx('placeholder')
      }, icon ? _react2.default.createElement('img', {
        src: icon,
        alt: 'add'
      }) : _react2.default.createElement(UploadIcon, null), _react2.default.createElement('div', null, _react2.default.createElement('span', null, titleSmall || 'Wgraj zdjęcia'), _react2.default.createElement('span', null, title || 'Przeciągnij zdjęcia'), _react2.default.createElement('span', null, subtitle || 'lub kliknij, aby załadować je z dysku')));
    }
  }, {
    key: 'renderProgress',
    value: function renderProgress() {
      var files = this.props.files;

      if (files.length === 0) {
        return null;
      }

      return _react2.default.createElement(_UploadProgress2.default, null);
    }
  }, {
    key: 'renderUploaded',
    value: function renderUploaded() {
      var files = this.props.files;

      if (files.length === 0) {
        return null;
      }

      return _react2.default.createElement('img', {
        src: files[0].url,
        alt: ''
      });
    }
  }]);

  return UploadDropzone;
}(_react.Component);

UploadDropzone.defaultProps = {
  TileComponent: _Tile2.default
};
exports.default = (0, _reactHoc.withStyles)(_UploadDropzoneModule2.default)(UploadDropzone);
module.exports = exports.default;